import { captureError } from '@/services/userMonitoring';
import * as MUTATIONS from './mutation-types.js'
import defaultState from './state'

export const coverageModule = {
  state: defaultState,
  mutations: {
    [MUTATIONS.CLEAR]: (state) => { Object.assign(state, defaultState) },
    [MUTATIONS.COVERAGE_LIST]: (state, value) => { state.COVERAGE_LIST = [...value] },
    [MUTATIONS.COVERAGE_WORK_TYPES]: (state, value) => { state.COVERAGE_WORK_TYPES = [...value] },
    [MUTATIONS.WORK_TYPES]: (state, value) => { state.WORK_TYPES = {...value} },
    [MUTATIONS.COVERAGE_POST_CODES]: (state, value) => { state.COVERAGE_POST_CODES = [...value] },
    [MUTATIONS.FOUND_LOCATIONS]: (state, value) => { state.FOUND_LOCATIONS = [...value] },
    [MUTATIONS.FOUND_COVERAGE_REGIONS]: (state, value) => { state.FOUND_COVERAGE_REGIONS = [...value] },
    [MUTATIONS.SELECTED_COVERAGE_AREAS]: (state, value) => { state.SELECTED_COVERAGE_AREAS = [...value] },
    [MUTATIONS.SELECTED_COVERAGE]: (state, value) => { state.SELECTED_COVERAGE = value },
  },
  actions: {
    saveCoverage: async function({state, commit}, coverage) {
      let proxy = state.COVERAGE_LIST;
      let id = coverage.id;
      if (id !== 'tmp') {
        await this._vm.$api.coverage.update(coverage.name, id)
          .then((response) => {
            proxy[state.COVERAGE_LIST.findIndex(cov => cov.id === id)] = response.data.data.coverage;
          })
          .catch(e => {
            captureError(e, {
              section: "coverage",
              action: "save",
              type: "api-request",
            });
          });
      } else {
        await this._vm.$api.coverage.create(coverage.name)
          .then((response) => {
            proxy = [...proxy, response.data.data.coverage];
            id = response.data.data.coverage.id;
          })
          .catch(e => {
            captureError(e, {
              section: "coverage",
              action: "create",
              type: "api-request",
            });
          });
      }
      commit(MUTATIONS.COVERAGE_LIST, proxy);
      return id;
    },
    getCoverage: async function({commit}) {
      await this._vm.$api.coverage.get()
        .then((response) => {
          commit(MUTATIONS.COVERAGE_LIST, response.data.data);
        })
        .catch(e => {
          captureError(e, {
            section: "coverage",
            action: "get",
            type: "api-request",
          });
        });
    },
    deleteCoverage: async function({commit, state}, id) {
      await this._vm.$api.coverage.delete(id)
        .then(() => {
          commit(MUTATIONS.COVERAGE_LIST, state.COVERAGE_LIST.filter(cov => cov.id !== id));
        })
        .catch(e => {
          captureError(e, {
            section: "coverage",
            action: "delete",
            type: "api-request",
          });
        });
    },
    getCoverageWorkTypes: async function({commit}, id) {
      await this._vm.$api.coverage.getWorkTypes(id)
        .then(response => {
          commit(MUTATIONS.COVERAGE_WORK_TYPES, response.data.data);
        })
        .catch(e => {
          captureError(e, {
            section: "coverage",
            action: "worktypes",
            type: "api-request",
          });
        });
    },
    getAllWorkTypes: async function({commit}) {
      await this._vm.$api.workTypes.get()
        .then(response => {
          commit(MUTATIONS.WORK_TYPES, response.data.data);
        })
        .catch(e => {
          captureError(e, {
            section: "coverage",
            action: "worktypes",
            type: "api-request",
          });
        });
    },
    getCoveragePostCodes: async function({commit}, id) {
      await this._vm.$api.coverage.getPostCodes(id).then(response => {
        commit(MUTATIONS.COVERAGE_POST_CODES, response.data.data);
        commit(MUTATIONS.SELECTED_COVERAGE_AREAS, response.data.meta.regions);
      })
      .catch(e => {
          captureError(e, {
            section: "coverage",
            action: "postcodes",
            type: "api-request",
        });
      });
    },
    findPostCode: async function({commit}, needle) {
      try {
        const { data: coverageRegions } = await this._vm.$api.coverageRegion.find(needle)
            commit(
              MUTATIONS.FOUND_COVERAGE_REGIONS,
              coverageRegions.data
                .sort((a, b) => a.name
                .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
            );
      } catch(e) {
        captureError(e, {
          section: "coverage",
          action: "postcodes",
          type: "api-request",
        });
      }
    }
  }
};
